import { BoatTypeDTO } from "../dto/BoatTypeDTO";
import { BoatType } from "../models/BoatType";

export const boatMapper = (dto: BoatTypeDTO): BoatType => {
  return new BoatType({
    id: dto.boatId,
    name: dto.boatName || null,
    active: dto.active === "Y",
    minCrew: dto.minCrew || null,
    maxCrew: dto.maxCrew || null,
  });
};
